// extracted by mini-css-extract-plugin
export default {"page-container":"page-container_page-container__9fv+Z"};